import { render } from "./PortfolioInfo.vue?vue&type=template&id=1877ccd5&scoped=true"
import script from "./PortfolioInfo.vue?vue&type=script&lang=js"
export * from "./PortfolioInfo.vue?vue&type=script&lang=js"

import "./PortfolioInfo.vue?vue&type=style&index=0&id=1877ccd5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1877ccd5"]])

export default __exports__